import { API_ENDPOINTS } from '@/api/endpoints';
import { Area } from '@/stores/SubprojectStore';
import { apiFetch } from '@/util/apiClient';
import { useQuery } from '@tanstack/react-query';
import { Lighting, LightingWithMetrics } from '../types';
import { addMetricsToResource } from './techMetrics';

export const useLightingWithMetrics = (conditionedSpaceArea?: Area) => {
  return useQuery<Lighting[], Error, LightingWithMetrics[]>({
    queryKey: ['lighting', 'withMetrics', conditionedSpaceArea?.value],
    queryFn: () =>
      apiFetch<Lighting[]>(API_ENDPOINTS.COMMON.technology.lighting),
    enabled: conditionedSpaceArea !== undefined,
    select: (data) => addMetricsToResource(data, conditionedSpaceArea),
  });
};
